import { useI18n } from "../i18n";

export default function PriceGuideCard({ icon: Icon, label, budget, mid, luxury, single }) {
  const { t } = useI18n();
  const isTiered = budget !== undefined;

  return (
    <div className="p-5 rounded-2xl bg-white border border-[#E6DED3]">
      <div className="flex items-center gap-2 text-[#57534E]">
        <div className="h-9 w-9 rounded-xl bg-[#F3EDE4] text-[#C85A32] grid place-items-center">
          <Icon className="h-4 w-4" />
        </div>
        <div className="text-sm font-medium text-[#1C1917]">{label}</div>
      </div>
      {isTiered ? (
        <div className="mt-4 grid grid-cols-3 gap-3 text-center">
          <Tier label={t("budget")} value={budget} />
          <Tier label={t("mid")} value={mid} highlight />
          <Tier label={t("luxury")} value={luxury} />
        </div>
      ) : (
        <div className="mt-4 flex items-baseline gap-1">
          <span className="text-xs text-[#78716C]">USD</span>
          <span className="font-display text-3xl text-[#1C1917]">{single}</span>
        </div>
      )}
    </div>
  );
}

function Tier({ label, value, highlight }) {
  return (
    <div className={`p-2 rounded-xl ${highlight ? "bg-[#1C1917] text-[#FAF7F2]" : "bg-[#F3EDE4] text-[#1C1917]"}`}>
      <div className="text-[10px] uppercase tracking-widest opacity-80">{label}</div>
      <div className="font-display text-lg mt-0.5">${value}</div>
    </div>
  );
}
